module.exports = __webpack_public_path__ + "img/001-rent.44980baa.svg";